// constants.js

export const IMPORTANT_CONSIDERATIONS_TEXT_SALES = `
Se enumeran a continuación las claves a tener en cuenta respecto a los gráficos:
  <ul>
    <li>
      Los gráficos de <strong>Top Gestiones Por Mes</strong>,
      <strong>Chats Mensuales Por Año</strong> y <strong>Asistencia Manual Mensual</strong>
      presentan datos recopilados mensualmente a lo largo del año, hasta el mes anterior al
      actual.
    </li>
    <li>
      El gráfico de <strong>Top Gestiones Por Día</strong> muestra las 15 gestiones más
      solicitadas diariamente, hasta 14 días previos a la fecha actual. Estas se muestran por dia seleccionado.
    </li>
    <li>
      Los gráficos de <strong>Asistencia Manual Diaria</strong> y
      <strong>Chats Diarios Por Mes</strong> exhiben datos acumulativos diarios por mes,
      incluyendo los del mes actual.
    </li>
    <li>
      El gráfico de <strong>Chats Diarios Por Mes</strong> mostrará los datos acumulados
      hasta el día previo al actual.
    </li>
  </ul>
  Por último, el botón <strong>'ACTUALIZAR DATOS'</strong> permite actualizar la informacion de
  los gráficos de Asistencia Manual Diaria, Chats Diarios Por Mes y Top Gestiones por Día.
  Cabe mencionar que este botón solo podrá ser utilizado
  <strong>una vez cada 3 horas.</strong>
`;
export const IMPORTANT_CONSIDERATIONS_TEXT_HEALTHDECISION = `
Se enumeran a continuación las claves a tener en cuenta respecto a los gráficos:
  <ul>
    <li>
      Los gráficos de <strong>Top Gestiones Por Mes</strong> y 
      <strong>Chats Mensuales Por Año</strong>
      presentan datos recopilados mensualmente a lo largo del año, hasta el mes anterior al
      actual.
    </li>
    <li>
      El gráfico de <strong>Top Gestiones Por Día</strong> muestra las 15 gestiones más
      solicitadas diariamente, hasta 14 días previos a la fecha actual. Estas se muestran por dia seleccionado.
    </li>
    <li>
      El gráfico de <strong>Chats Diarios Por Mes</strong> mostrará los datos acumulados
      hasta el día previo al actual.
    </li>
  </ul>
  Por último, el botón <strong>'ACTUALIZAR DATOS'</strong> permite actualizar la informacion de
  los gráficos de Chats Diarios Por Mes y Top Gestiones por Día.
  Cabe mencionar que este botón solo podrá ser utilizado
  <strong>una vez cada 3 horas.</strong>
`;

export const UPDATE_BUTTON_TEXT = 'ACTUALIZAR DATOS';
